import "./AboutHobby.scss";

function AboutHobby() {

    return (
        <section class="about-hobby">
            <section class="about-hobby__center-wrap">
                <h2 class="about-hobby__title">Hobbies</h2>
                <p class="about-hobby__item">Singing 🎤, Fitness 🚴‍♀️, Travel ✈️, Technology 🤖</p>
            </section>
        </section>
    )
}

export default AboutHobby;